import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonEmptyState } from './EmptyState.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonEmptyState({ prefix }));
}
